<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            Registro cuenta de usuario
            <div class="card-actions">
              <button
                class="btn btn-primary"
                v-b-tooltip.hover
                title="Volver al inicio"
                v-if="!cuenta_creada"
                @click="Inicio()"
              >
                <i class="icon-arrow-left"></i>
              </button>
            </div>
          </div>
          <div class="card-body">
            <form
              v-on:submit.prevent="crearCuentaUsuario"
              v-if="procesando == false && error == false && cuenta_creada == false"
            >
              <h2>Datos de identificación</h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="primer_nombre">Nombre / First name</label>
                    <b-form-input
                      type="text"
                      :state="validarPrimerNombre()"
                      v-model="usuario.primer_nombre"
                      name="primer_nombre"
                      :disabled="procesando"
                      placeholder="Ingrese nombre"
                    ></b-form-input>
                    <b-form-valid-feedback>Nombre válido.</b-form-valid-feedback>
                    <b-form-invalid-feedback>Ingrese nombre válido. Ej: John</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="primer_apellido">Apellido / Last name</label>
                    <b-form-input
                      type="text"
                      :state="validarPrimerApellido()"
                      v-model="usuario.primer_apellido"
                      name="primer_apellido"
                      :disabled="procesando"
                      placeholder="Ingrese apellido"
                    ></b-form-input>
                    <b-form-valid-feedback>Apellido válido.</b-form-valid-feedback>
                    <b-form-invalid-feedback>Ingrese apellido válido. Ej: Doe</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="genero">Sexo / Sex</label>
                    <b-form-select
                      class="form-control"
                      :state="validarGenero()"
                      name="genero"
                      :disabled="procesando"
                      v-model="usuario.genero"
                    >
                      <option disabled value>Seleccione sexo</option>
                      <option
                        v-for="genero in generos"
                        v-bind:key="genero.codigo"
                        v-bind:value="genero.codigo"
                      >{{ genero.nombre }}</option>
                    </b-form-select>
                    <b-form-valid-feedback>Sexo válido.</b-form-valid-feedback>
                    <b-form-invalid-feedback>Seleccione un sexo válido.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="fecha_nacimiento">Fecha de nacimiento / Birthdate</label>
                    <b-card class="bg-light">
                      <b-row>
                        <b-col sm="7">
                          <datepicker
                            v-model="fecha_nacimiento"
                            :value="obtenerFechaNacimientoRestriccion()"
                            type="date"
                            :editable="false"
                            :lang="'es'"
                            @change="obtenerFechaNacimiento()"
                            :format="'DD/MM/YYYY'"
                            :clearable="false"
                            :not-after="obtenerFechaNacimientoRestriccion()"
                          ></datepicker>
                          <b-form-input
                            type="text"
                            :state="validarFechaNacimiento()"
                            v-model="usuario.fecha_nacimiento"
                            name="fecha_nacimiento"
                            v-show="false"
                            :disabled="procesando"
                            placeholder="Ingrese fecha de nacimiento"
                          ></b-form-input>
                          <b-form-valid-feedback>Fecha de nacimiento válida.</b-form-valid-feedback>
                          <b-form-invalid-feedback>Debe seleccionar una fecha de nacimiento válida.</b-form-invalid-feedback>
                        </b-col>
                        <b-col sm="5">
                          <div
                            class="alert alert-warning bg-warning"
                            role="alert"
                          >Recuerde que Ud debe tener una edad mínima de 14 años.</div>
                        </b-col>
                      </b-row>
                    </b-card>
                  </b-form-group>
                </b-col>
              </b-row>

              <h2>Datos de acceso</h2>
              <hr />

              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <label for="correo_electronico">E-mail</label>
                    <b-form-input
                      type="email"
                      :state="validarCorreoElectronico()"
                      v-model="usuario.correo_electronico"
                      name="correo_electronico"
                      :disabled="procesando"
                      placeholder="Ingrese correo electrónico"
                    ></b-form-input>
                    <b-form-valid-feedback>Correo electrónico válido.</b-form-valid-feedback>
                    <b-form-invalid-feedback>Ingrese un correo electrónico válido. Ej: correo@dominio.com</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <label for="clave">Contraseña / Password</label>
                    <b-form-input
                      type="password"
                      :state="validarClave()"
                      v-model="usuario.clave"
                      name="clave"
                      :disabled="procesando"
                      placeholder="Ingrese contraseña"
                    ></b-form-input>
                    <b-form-valid-feedback>Clave válida.</b-form-valid-feedback>
                    <b-form-invalid-feedback>Ingrese una clave válida. Debe contener mínimo (8) carácteres.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <h2>Personalización avatar</h2>
              <hr />

              <br />
              <br />

              <b-row>
                <b-col sm="6" class="text-center">
                  <img
                    :src="'static/img/avatars/' + usuario.ruta_imagen_usuario"
                    v-if="!Boolean(imagen_avatar)"
                    style="width: 200px; height: 200px;"
                    class="img-avatar"
                    alt="Avatar seleccionado"
                  />
                  <img
                    :src="imagen_avatar"
                    v-if="Boolean(imagen_avatar)"
                    style="width: 200px; height: 200px;"
                    class="img-avatar"
                    alt="Avatar seleccionado"
                  />
                </b-col>
                <b-col sm="6">
                  <b-list-group>
                    <b-list-group-item
                      v-for="(avatar, index) in avatares"
                      :key="avatar.ruta_imagen_usuario"
                      :active="avatar.active"
                      :disabled="avatar.disabled"
                      @click="seleccionarOpcionAvatar(index)"
                      style="cursor: pointer;"
                      class="d-flex justify-content-between align-items-center"
                    >
                      <span
                        v-if="avatar.item < 3 || avatar.item === 3 && avatar.active === false"
                      >{{avatar.opcion}}</span>

                      <div v-if="avatar.item > 2 && avatar.active === true">
                        <label variant="outline-info text-white">Seleccione una imagen</label>

                        <picture-input
                          ref="file_avatar"
                          @change="onChangedImage"
                          @remove="onRemovedImage"
                          accept="image/jpeg, image/png, image/gif"
                          buttonClass="btn btn-outline-info text-white"
                          removeButtonClass="btn btn-danger"
                          :removable="true"
                          :customStrings="{
                            upload: '<h1>Upload it!</h1>',
                            drag: 'Arrastre y suelte su imagen aquí',
                            change: 'Cambiar',
                            remove: 'Quitar'
                          }"
                        ></picture-input>
                      </div>

                      <img
                        :src="'static/img/avatars/' + avatar.ruta_imagen_usuario"
                        v-if="avatar.item < 3 || avatar.item === 3 && !Boolean(imagen_avatar)"
                        style="width: 30px; height: 30px;"
                        class="img-avatar"
                        :alt="avatar.opcion"
                      />
                      <img
                        :src="imagen_avatar"
                        v-if="avatar.item === 3 && avatar.active === true && Boolean(imagen_avatar)"
                        style="width: 30px; height: 30px;"
                        class="img-avatar"
                        :alt="avatar.opcion"
                      />
                    </b-list-group-item>
                  </b-list-group>
                </b-col>
              </b-row>

              <br />
              <br />

              <h2>Términos y condiciones</h2>
              <hr />
              <b-row>
                <b-col sm="1">
                  <c-switch
                    type="text"
                    size="lg"
                    variant="success"
                    on="Si"
                    off="No"
                    v-model="usuario.acepta_terminos"
                    name="acepta_terminos"
                    :disabled="procesando"
                    :checked="usuario.acepta_terminos"
                  />
                </b-col>
                <b-col sm="11">
                  Acepto términos y condiciones.
                  <br />
                  <small>
                    Para conocer los términos y condiciones de
                    <span
                      style="cursor:pointer"
                      class="text-primary"
                      @click="abrirModalTerminosCondiciones()"
                    >clic aquí</span>.
                  </small>
                </b-col>
                <b-col sm="12">
                  <b-form-group>
                    <b-form-input
                      type="text"
                      v-show="false"
                      :state="validarAceptaTerminosCondiciones()"
                      v-model="usuario.acepta_terminos"
                      name="acepta_terminos"
                      :disabled="procesando"
                    ></b-form-input>
                    <b-form-valid-feedback>Acepta términos y condiciones válido.</b-form-valid-feedback>
                    <b-form-invalid-feedback>Debe aceptar términos y condiciones.</b-form-invalid-feedback>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-modal
                ref="modalTerminosCondiciones"
                title="Términos y condiciones"
                no-close-on-backdrop
                no-close-on-esc
                centered
                hide-footer
                hide-header-close
                class="modal-info"
              >
                <b-card-group>
                  <b-card no-body class="p-4">
                    <b-card-body>
                      <h1>Términos y condiciones</h1>
                      <p>Contenido términos y condiciones</p>

                      <b-row>
                        <b-col cols="4" class="text-right">
                          <button
                            variant="success"
                            type="button"
                            class="btn btn-success px-4"
                            @click="AceptarModalTerminosCondiciones()"
                            :disabled="procesando"
                          >Aceptar</button>
                        </b-col>
                        <b-col cols="4" class="text-right">
                          <button
                            variant="secondary"
                            type="button"
                            class="btn btn-secondary px-4"
                            @click="cerrarModalTerminosCondiciones()"
                            :disabled="procesando"
                          >Cerrar</button>
                        </b-col>
                      </b-row>
                    </b-card-body>
                  </b-card>
                </b-card-group>
              </b-modal>

              <h2>Crear cuenta de usuario</h2>
              <hr />

              <!-- <pre>{{usuario}}</pre> -->

              <b-row>
                <b-col sm="12">
                  <b-form-group>
                    <c-switch
                      type="text"
                      size="lg"
                      v-show="false"
                      variant="success"
                      on="Si"
                      off="No"
                      v-model="usuario.activo"
                      name="activo"
                      :disabled="procesando"
                      :checked="usuario.activo"
                    />
                    <b-button
                      type="button"
                      variant="secondary"
                      style="cursor: not-allowed;"
                      disabled
                      v-if="!validarFormulario ()"
                      v-b-tooltip.hover
                      title="Crear cuenta de usuario"
                    >
                      <i class="fa fa-floppy-o fa-lg"></i> Crear cuenta de usuario
                    </b-button>
                    <b-button
                      type="submit"
                      variant="primary"
                      v-if="validarFormulario ()"
                      v-b-tooltip.hover
                      title="Crear cuenta de usuario"
                    >
                      <i class="fa fa-floppy-o fa-lg"></i> Crear cuenta de usuario
                    </b-button>
                    <!-- <b-alert show variant="warning">
                      <h3>Próximamente se permitirá el acceso al público general. En el momento sólo se permiten acceso a usuarios corporativos invitados.</h3>
                      <b-button type="button" variant="primary" :disabled="true" v-b-tooltip.hover title="Crear cuenta de usuario"><i class="fa fa-floppy-o fa-lg"></i></b-button>
                    </b-alert>-->
                  </b-form-group>
                </b-col>
              </b-row>
            </form>
            <b-alert show class="text-center" variant="info" v-else-if="procesando == true">
              <b-progress height="20px" :max="100" variant="info" striped :animated="true">
                <b-progress-bar :value="100" :label="'&lt;strong&gt;Procesando...&lt;/strong&gt;'"></b-progress-bar>
              </b-progress>
            </b-alert>
            <b-alert
              show
              class="text-center"
              variant="info"
              v-else-if="procesando == false && error == false && cuenta_creada == true"
            >
              <h3>Felicitaciones!!!</h3>
              {{mensaje_success}}
              <br />
              <br />
              <b-button type="button" variant="success" @click="iniciarSesion()">Iniciar sesión</b-button>
            </b-alert>
            <b-alert
              show
              class="text-center"
              variant="danger"
              v-else-if="procesando == false && error == true && cuenta_creada == false"
            >{{mensaje_error}}</b-alert>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import router from '@/router/index.js'
import auth from '@/js/auth.js'
import usuario from '@/js/usuario.js'
import session from '@/js/session.js'
import genero from '@/js/genero.js'
import cSwitch from '@/components/Switch'
import Datepicker from 'vue2-datepicker'
import moment from 'moment'

import { EventBus } from '@/js/EventBus.js'

import validationField from 'validationField'
import PictureInput from 'vue-picture-input'

export default {
  name: 'registro-usuario',
  components: {
    cSwitch,
    'datepicker': Datepicker,
    moment,
    PictureInput
  },
  mounted () {
    this.procesando = false
    this.error = false

    this.listarGeneros()
  },
  data () {
    return {
      procesando: true,
      error: false,
      cuenta_creada: false,
      mensaje_error: 'Se ha presentado un error en el sistema. Por favor intente más tarde. Si el error continua por favor comuníquese con el administrador del sistema.',
      mensaje_success: 'Cuenta creada satisfactoriamente.',
      generos: [],
      avatares: [
        {
          item: 0,
          opcion: 'Sin foto',
          ruta_imagen_usuario: 'registered.png',
          active: true,
          disabled: false
        },
        // {
        //   item: 1,
        //   opcion: 'Masculino',
        //   ruta_imagen_usuario: 'masculino.png',
        //   active: false,
        //   disabled: false
        // },
        // {
        //   item: 2,
        //   opcion: 'Femenino',
        //   ruta_imagen_usuario: 'femenino.png',
        //   active: false,
        //   disabled: false
        // },
        {
          item: 3,
          opcion: 'Seleccionar una imagen',
          ruta_imagen_usuario: 'personalizado.png',
          active: false,
          disabled: false
        }
      ],
      fecha_nacimiento: this.obtenerFechaNacimientoRestriccion(),
      imagen_avatar: null,
      file_imagen_avatar: null,
      usuario: {
        primer_nombre: '',
        segundo_nombre: '',
        primer_apellido: '',
        segundo_apellido: '',
        genero: '',
        fecha_nacimiento: this.obtenerFechaNacimientoPermitida(),
        correo_electronico: '',
        confirmacion_correo_electronico: '',
        clave: '',
        confirmacion_clave: '',
        imagen_usuario_personalizada: false,
        ruta_imagen_usuario: 'registered.png',
        acepta_terminos: false,
        activo: true
      }
    }
  },
  computed: {
    acepta_terminos: {
      get () {
        return this.usuario.acepta_terminos === true
      },
      set (newValue) {
        this.usuario.acepta_terminos = newValue
      }
    }
  },
  methods: {
    listarGeneros () {
      this.procesando = true
      this.error = false

      genero.getListadoGeneros().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false

          this.generos = response.data
        } else {
          this.procesando = false
          this.error = true
          // console.log(response)
        }
      })
    },
    createInput (file) {
      var reader = new FileReader()
      reader.onload = (e) => {
        this.imagen_avatar = reader.result
      }

      reader.readAsDataURL(file)
    },
    onChangedImage () {
      if (this.$refs.file_avatar[0].file) {
        this.createInput(this.$refs.file_avatar[0].file)
      }
    },
    onRemovedImage () {
      this.usuario.ruta_imagen_usuario = 'personalizado.png'
      this.imagen_avatar = null
    },
    validarFormulario () {
      let valido = true

      if (
        !this.validarPrimerNombre() ||
        // !this.validarSegundoNombre() ||
        !this.validarPrimerApellido() ||
        // !this.validarSegundoApellido() ||
        !this.validarGenero() ||
        !this.validarFechaNacimiento() ||
        !this.validarCorreoElectronico() ||
        // !this.validarConfirmacionCorreoElectronico() ||
        !this.validarClave() ||
        // !this.validarConfirmacionClave() ||
        !this.validarAceptaTerminosCondiciones()
      ) {
        valido = false
      }
      return valido
    },
    validarPrimerNombre () {
      let valido = true

      if (!this.usuario.primer_nombre || !validationField('short-string', this.usuario.primer_nombre)) {
        valido = false
      }
      return valido
    },
    validarSegundoNombre () {
      let valido = true

      if (this.usuario.segundo_nombre && !validationField('short-string', this.usuario.segundo_nombre)) {
        valido = false
      }
      return valido
    },
    validarPrimerApellido () {
      let valido = true

      if (!this.usuario.primer_apellido || !validationField('short-string', this.usuario.primer_apellido)) {
        valido = false
      }
      return valido
    },
    validarSegundoApellido () {
      let valido = true

      if (this.usuario.segundo_apellido && !validationField('short-string', this.usuario.segundo_apellido)) {
        valido = false
      }
      return valido
    },
    validarGenero () {
      let valido = true

      if (!this.usuario.genero) {
        valido = false
      }
      return valido
    },
    obtenerFechaNacimiento () {
      this.usuario.fecha_nacimiento = moment(this.fecha_nacimiento).format('YYYY-MM-DD')
    },
    obtenerFechaNacimientoPermitida () {
      return moment().add(-10, 'year').add(-1, 'day').format('YYYY-MM-DD')
    },
    obtenerFechaNacimientoRestriccion () {
      return moment().add(-14, 'year').add(0, 'day').format('YYYY-MM-DD')
    },
    validarFechaNacimiento () {
      let valido = true

      if (!this.usuario.fecha_nacimiento || this.usuario.fecha_nacimiento >= this.obtenerFechaNacimientoRestriccion()) {
        valido = false
      }
      return valido
    },
    validarCorreoElectronico () {
      let valido = true

      if (!this.usuario.correo_electronico || !validationField('email', this.usuario.correo_electronico)) {
        valido = false
      }
      return valido
    },
    validarConfirmacionCorreoElectronico () {
      let valido = true

      if (!this.usuario.confirmacion_correo_electronico || this.usuario.correo_electronico !== this.usuario.confirmacion_correo_electronico) {
        valido = false
      }
      return valido
    },
    validarClave () {
      let valido = true

      if (!this.usuario.clave || !validationField('password', this.usuario.clave)) {
        valido = false
      }
      return valido
    },
    validarConfirmacionClave () {
      let valido = true

      if (!this.usuario.confirmacion_clave || this.usuario.clave !== this.usuario.confirmacion_clave) {
        valido = false
      }
      return valido
    },
    validarAceptaTerminosCondiciones () {
      let valido = true

      if (!this.usuario.acepta_terminos) {
        valido = false
      }
      return valido
    },
    seleccionarOpcionAvatar (opcion) {
      if (opcion < 1 || (opcion === 1 && this.avatares[opcion].active === false)) {
        this.imagen_avatar = null
      }

      this.avatares.forEach(function (avatar, value) {
        avatar.active = false
      })

      if (this.avatares[opcion].item < 3) {
        this.avatares[opcion].imagen_usuario_personalizada = false
        this.usuario.imagen_usuario_personalizada = false
      } else {
        this.avatares[opcion].imagen_usuario_personalizada = true
        this.usuario.imagen_usuario_personalizada = true
      }
      this.usuario.ruta_imagen_usuario = this.avatares[opcion].ruta_imagen_usuario

      this.avatares[opcion].active = true
    },
    abrirModalTerminosCondiciones () {
      this.$refs.modalTerminosCondiciones.show()
    },
    aceptarModalTerminosCondiciones () {
      this.usuario.acepta_terminos = true
      this.$refs.modalTerminosCondiciones.hide()
    },
    cerrarModalTerminosCondiciones () {
      this.$refs.modalTerminosCondiciones.hide()
    },
    crearCuentaUsuario () {
      this.procesando = true
      this.error = false

      if (this.usuario.imagen_usuario_personalizada === true) {
        usuario.contentType = 'multipart/form-data'

        const imagen = this.$refs.file_avatar[0].file
        usuario.usuario = new FormData()
        usuario.usuario.append('primer_nombre', this.usuario.primer_nombre)
        usuario.usuario.append('segundo_nombre', this.usuario.segundo_nombre)
        usuario.usuario.append('primer_apellido', this.usuario.primer_apellido)
        usuario.usuario.append('segundo_apellido', this.usuario.segundo_apellido)
        usuario.usuario.append('genero', this.usuario.genero)
        usuario.usuario.append('fecha_nacimiento', this.usuario.fecha_nacimiento)
        usuario.usuario.append('correo_electronico', this.usuario.correo_electronico)
        usuario.usuario.append('confirmacion_correo_electronico', this.usuario.correo_electronico)
        usuario.usuario.append('clave', this.usuario.clave)
        usuario.usuario.append('confirmacion_clave', this.usuario.clave)
        usuario.usuario.append('ruta_imagen_usuario', imagen)
        usuario.usuario.append('imagen_usuario_personalizada', this.usuario.imagen_usuario_personalizada)
        usuario.usuario.append('activo', this.usuario.activo)
        usuario.usuario.append('acepta_terminos', this.usuario.acepta_terminos)
      } else {
        usuario.contentType = 'application/json'
        usuario.usuario = {
          ...this.usuario,
          confirmacion_correo_electronico: this.usuario.correo_electronico,
          confirmacion_clave: this.usuario.clave
        }
      }

      usuario.registerUsuario().then(response => {
        if (response.status === 'success') {
          this.procesando = false
          this.error = false
          this.cuenta_creada = true
        } else {
          this.procesando = false
          this.error = false // true
          // console.log(response)
        }
      })
    },
    iniciarSesion () {
      auth.email = this.usuario.correo_electronico
      auth.password = this.usuario.clave
      this.procesando = true
      this.error = false

      auth.signin().then(response => {
        if (response.status === 'success') {
          sessionStorage.setItem('token', JSON.stringify(response.data))

          // Consultar datos del usuario autenticado
          usuario.getUsuarioAutenticado().then(response => {
            if (response.status === 'success') {
              this.error = false
              this.procesando = false

              let datosUsuarioAutenticado = response.data
              datosUsuarioAutenticado.imagen_genero = datosUsuarioAutenticado.imagen_genero

              sessionStorage.setItem('datos_usuario_autenticado', JSON.stringify(datosUsuarioAutenticado))
              sessionStorage.setItem('seccion', 'Home')

              this.$parent.$parent.authenticated = true
              this.$parent.$parent.datos_usuario_autenticado = response.data
              this.$parent.$parent.ruta_back = Vue.http.options.root

              EventBus.$emit('authenticationEvent', {})

              session.loginChat()

              router.push({
                name: 'home'
              })
            } else {
              // console.log(response)
              this.error = true
              this.procesando = false
            }
          })
        } else {
          // console.log(response)
          this.error = true
          this.procesando = false
        }
      })
    },
    abrirModalInicioSesion () {
      this.Inicio()
      this.$parent.$parent.$children[0].$children[1].abrirModalInicioSesion()
    },
    Inicio () {
      router.push({
        name: 'home'
      })
    }
  }

}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/views/Usuario/Registro.vue